export default __webpack_public_path__ + "static/media/logo.258732c4.png";